import React, { useState } from "react";
import { PasswordVisibilityButton } from "../auth/AuthUI";

const Input = ({ label, error, revealable = false, ...props }) => {
  const [visible, setVisible] = useState(false);
  const revealed = revealable && props.type === "password" && visible;
  const field = (
    <input
      {...props}
      type={revealed ? "text" : props.type}
      className={`w-full px-0 py-3 border-0 border-b-2 transition-all duration-200 bg-transparent ${
        error
          ? "border-red-500 focus:border-red-500"
          : "border-gray-300 focus:border-teal-500"
      } ${props.disabled ? "bg-gray-50 cursor-not-allowed text-gray-500" : ""} ${
        revealable ? "pr-10" : ""
      } ${props.className || ""}`}
    />
  );

  return (
    <div className="w-full">
      {label && (
        <label className="block text-sm font-medium text-gray-900 mb-2">
          {label}
          {props.required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      {revealable ? (
        <div className="relative">
          {field}
          <PasswordVisibilityButton visible={visible} onToggle={() => setVisible((current) => !current)} />
        </div>
      ) : field}
      {error && <p className="mt-1 text-sm text-red-600">{error}</p>}
    </div>
  );
};

export default Input;